import { FormControl } from '@angular/forms';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { QuestionForm } from './question-form.model';

export class QuestionFormNPS extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(index: number, pageId: string): void {
    super.initEmpty(index, pageId);
    this.form.get('type').setValue(QuestionType.NPS);
  }

  init(question: Question): void {
    super.init(question);
    this.form.get('type').setValue(QuestionType.NPS);
  }

  private extendFormGroup(): void {
    this.form.addControl('minValueText', new FormControl<string>('Not at all likely'));
    this.form.addControl('maxValueText', new FormControl<string>('Extremely likely'));
  }
}
